import { createI18n } from 'vue-i18n';

import en from '@/locales/en.json';
import it from '@/locales/it.json';
import es from '@/locales/es.json';

const defaultLocale = 'en';

export default createI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: {
    en,
    it,
    es,
  },
});
